import { BehaviorSubject } from 'rxjs';
import { CoordinatorService } from './coordinator.service';
import { FilesystemCommunicator } from './filesystem-communicator';
import { ProjectInList } from './project-in-list';

export type EXPORT_PART = 'keyword' | 'databin' | 'databins';

export type BOOKPARAMS = {
    [tag: string]: any;
};

export type REPORTPARAMS = {
    project: any;
    xitemLs: any[];
};

export type CLOUDSTOREPARAMS = {
    blob: Blob;
    currentUserId: string;
    cloudInfo: any;
};

export type EXPORTPARAMS = {
    projectId: string;
    type: string;
    params?: any;
};

export type STOREPARAMS = {
    type: string;
    id: string;
    projectId?: string;
    valueMap: Map<string, any>;
};

export type LISTPARAMS = {
    projectId?: string;
};

export type IMPORTPARAMS = {
    file: File;
};

type DT = {
    id: string;
    type: string;
};

export type DELETEPARAMS = {
    projectId: string;
    ls: DT[];
};

export class Manifest$ {
    isReady = false;
    private _pauseStore = false;

    response$ = new BehaviorSubject<any>(null);

    lockedSet = new Set<string>();

    constructor(private coords: CoordinatorService) {}

    clear() {
        this.lockedSet.clear();
    }

    onStart() {
        this.coords.worker$.manifest.response$.subscribe({
            next: (x) => !x.mId && this._workerResponse(x.payload),
            error: (e) => console.log(e),
        });

        this.coords.worker$.manifest.reportSuccess$.subscribe({
            next: (x) => !x.mId && this._workerResponse(x),
            error: (e) => console.log(e),
        });
    }

    private _loadType(params: any) {
        if (!params || !params.resultMap) return;
        // console.log(params.type)
        switch (params.type) {
            // case "project":
            //     return this.coords.project$.manifestLoadResponse(params)
            // case "databin":
            //     return this.coords.databin$.manifestLoadResponse(params)
            // case "databin-xitemLs":
            //     return this.coords.databin$.manifestLoadXitemLsResponse(params)
            // case "dataset-xitemLs":
            //     return this.coords.dataset$.manifestLoadResponse(params)
            // case "connection*":
            //     return this.coords.databin$.manifestLoadConnectionResponse(params)
            // case "pin":
            //     return this.coords.pin$.manifestLoadResponse(params)
            // case "keyword":
            //     return this.coords.keyword$.manifestLoadResponse(params)
            // case "view":
            //     return this.coords.view$.manifestLoadResponse(params)
            // case "comment":
            //     return this.coords.comment$.manifestLoadResponse(params)
            // case "style":
            //     return this.coords.highlight$.manifestLoadResponse(params)
            // case "bt*":
            //     return this.coords.binaryTree$.manifestLoadResponse(params)
            case 'team':
                return this.coords.user$.manifestLoadResponse(params);
        }

        this.coords.utils$.consoleInfo({
            tag: 'Manifest Load Type',
            background: 'aqua',
            color: 'darkgreen',
            payload: params,
        });
    }

    syncList(projectId?: string): void {
        projectId = projectId || this.coords.project$.currentId;
        this.post('list-sync', {
            projectId: projectId,
        });
    }

    // localProjectList() {
    //     this.post("list-local-projects", {
    //     })
    // }

    // async update2(mp: Map<string, any[]>) {
    //     console.log("UPDATE2", mp)
    //     this.coords.project$.consoleMark

    //     this.coords.binaryTree$.update2(mp)
    //     this.coords.comment$.update2(mp)
    // }

    load(type: string, projectId?: string) {
        this.post('load-type', {
            projectId: projectId || this.coords.project$.currentId,
            type: type,
        });
    }

    store(params: STOREPARAMS) {
        const projectId = params.type === 'project' ? params.id : this.coords.project$.currentId;
        if (!projectId) return;
        params.projectId = projectId;
        // console.log("MMM", params)
        this.post('store-file', params);
    }

    export(projectId: string) {
        this.post('export-project', { projectId: projectId });
    }

    exportPart(type: EXPORT_PART, params?: any) {
        this.post('export-part', {
            projectId: this.coords.project$.currentId,
            type: type,
            params: params,
        });
    }

    copyPart(type: EXPORT_PART, params?: any) {
        this.post('copy-part', {
            projectId: this.coords.project$.currentId,
            type: type,
            params: params,
        });
    }

    // import(file: File) {
    //     this.post('import-project', { file: file });
    // }

    async importPart(type: EXPORT_PART) {
        const obj = await this.coords.filesystem$.pickJsonFile();
        if (obj instanceof File)
            return this.post('import-part', {
                file: obj,
                type: type,
            });
        if (obj.type === 'search-procedure') this.coords.keyword$.importSearchProcedure(obj);
    }

    async delete(ls: DT[]) {
        const p$ = this.coords.project$;
        const projectId = p$.currentId;
        if (!projectId) return;

        const resp = (await this.coords.worker$.manifest.call('delete-files', {
            projectId: projectId,
            ls: ls,
        })) as any;

        p$.current?.team?.currentUser.deleteUpdate(ls.map((dt) => `${dt.type}_${dt.id}`));
        return resp;
    }

    private _workerResponse(params: any) {
        if (!params) return;
        if (params.mId) return;
        if (params.type === 'lock-file') return;
        const p$ = this.coords.project$;
        const cm = p$.current?.team?.currentUser;

        switch (params.action) {
            case 'initialized':
                p$.localProjectListResponse(params.localProjectLs);
                this.isReady = true;
                this.coords.display$.markForCheck();

                return;
            case 'save-response':
                return;
            case 'load-type':
                return this._loadType(params);

            // case "list-local-projects":
            //     return p$.localProjectListResponse(params.ls)
            case 'delete-project':
                return;
            // return this.coords.project$.dialogList()
            case 'export-project-file':
                this._saveExport(params);
                this.coords.display$.closeSnackbar();
                return;
            case 'project-imported':
                // console.log('PROJECT IMPORTED', params);
                if (!params.projectId) {
                    this.coords.display$.error(
                        'project-imported',
                        this.coords.text('wrongFileFormat'),
                    );
                    return;
                }

                params.projectData.cloudInfo = params.cloudInfo;
                const pil = new ProjectInList(this.coords, params.projectData);
                return pil.select();
            case 'save-attachment':
                // return this.coords.attachment$.saveResponse(params);
            case 'success':
            case 'save-file':
            case 'lock-file':
            case 'store-file':
                return;
            case 'export-link':
                return this.response$.next(params.payload);
            // case "import-project-list":
            //     switch (params.target) {
            //         case "resource":
            //             const cc = this.coords.databin$
            //                 .editedConnection$?.getValue()
            //             if (!cc) return
            //             return (cc.communicator as FilesystemCommunicator)
            //                 .importProjectLs(params.ls)

            //     }
            //     console.log("UNKNOWN TARGET: " + params.target)
            //     break
            case 'import-part':
                switch (params.type) {
                    case 'keyword':
                        return this.coords.keyword$.importResponse(params);
                    case 'databin':
                        return this.coords.databin$.importResponse(params);
                }
                return;
            case 'delete-files':
                cm?.deleteUpdate(params.ls);
                return;
            // case "saved-cache-file":
            //     return this.coords.user$.current!.currentCloudSync?.cacheSaveConfirmed(params)
            // return this.coords.project$
            //     .projectTeam?.currentMember?.fileStored(params.file)
            // case "uploads-updated":
            //     return cm?.uploadsUpdate(params)
            case 'upload-all':
                return this.coords.upload$.uploadAllResponse(params.resp);
            // return this.coords.upload$.setExplicitUpload(params.uploadLs)
            // return cm?.uploadAllResponse()

            case 'upload-file':
                return this.coords.upload$.manifestResponse(params);
            case 'log-data':
                return this.coords.logs$.manifestResponse(params);
            default:
                this.coords.utils$.consoleInfo({
                    tag: 'Manifest Response',
                    background: 'blue',
                    color: 'orange',
                    payload: params,
                });
        }
    }

    private _saveExport(params: any) {
        this.coords.filesystem$.saveFile2(params.filename + '.ref', params.payload);
    }

    saveDialog() {
        this.coords.display$.dialog$.next({ action: 'save' });
    }

    loadDialog() {
        this.coords.display$.dialog$.next({ action: 'load' });
    }

    async post(
        action: string,
        payload:
            | STOREPARAMS
            | CLOUDSTOREPARAMS
            | LISTPARAMS
            | DELETEPARAMS
            | IMPORTPARAMS
            | EXPORTPARAMS
            | REPORTPARAMS
            | BOOKPARAMS
            | null
            | { payload: any; target: string },
    ) {
        if (action == 'store-file' && this.pauseStore) return;
        if (action == 'api' && !this.isReady) {
            setTimeout(() => this.post(action, payload), 300);
            return;
        }
        const dct = {
            action: action,
            isCloud: this.coords.project$.current?.isCloud,
            payload: payload || {},
        };

        // this.coords.utils$.consoleInfo({
        //     tag: 'Manifest Load Type',
        //     background: 'aqua',
        //     color: 'darkgreen',
        //     payload,
        // });
        return this.coords.worker$.manifest.directPost(dct);
    }

    async projectStatus(projectId: string) {
        const rH = await navigator.storage.getDirectory();
        const mp = new Map<string, any>();
        try {
            const pH = (await rH.getDirectoryHandle(projectId)) as any;
            mp.set('_current', await this._projectStatusDir(pH));
            try {
                const tH = (await pH.getDirectoryHandle('_team')) as any;
                for await (const k of tH.keys()) {
                    const mH = await tH.getDirectoryHandle(k);
                    mp.set(k, await this._projectStatusDir(mH));
                }
            } catch (e) {}
        } catch (e) {
            console.error(e);
        } finally {
            return mp;
        }
    }

    private async _projectStatusDir(dH: FileSystemDirectoryHandle) {
        const mp = new Map<string, string[]>();
        for await (const v of (dH as any).values()) {
            if (v.kind == 'file') {
                const fn = v.name;
                const tag = fn.substring(0, fn.indexOf('_'));
                const ls = mp.get(tag) || [];
                if (!ls.length) mp.set(tag, ls);
                ls.push(fn);
            }
        }
        return { dH: dH, mp: mp };
    }

    public get pauseStore() {
        const p = this.coords.project$.current;

        if (p?.isViewMode) return true;
        return this._pauseStore;
    }
    public set pauseStore(value) {
        this._pauseStore = value;
    }

    // localAttachmentFile(cachename: string, mimetype?: string) {
    //     console.log('LOCAL ATTACHMENT FILE', cachename, mimetype);
    // }
}
